__turbopack_context__.v({
  "container": "styles-module-scss-module___u2jQW__container",
  "copy_url_button": "styles-module-scss-module___u2jQW__copy_url_button",
  "copy_url_container": "styles-module-scss-module___u2jQW__copy_url_container",
  "copy_url_display": "styles-module-scss-module___u2jQW__copy_url_display",
  "share_button": "styles-module-scss-module___u2jQW__share_button",
  "share_button_email": "styles-module-scss-module___u2jQW__share_button_email",
  "share_button_facebook": "styles-module-scss-module___u2jQW__share_button_facebook",
  "share_button_linkedin": "styles-module-scss-module___u2jQW__share_button_linkedin",
  "share_button_x": "styles-module-scss-module___u2jQW__share_button_x",
  "share_buttons_container": "styles-module-scss-module___u2jQW__share_buttons_container",
});
